<template>
  <BaseCard
    tile
    class="px-6"
    :hide-divider="$vuetify.breakpoint.mdAndUp"
    :class="$vuetify.breakpoint.mdAndUp ? 'transparent' : 'neutral tone-100'"
  >
    <template #header>
      <BaseSubheader
        class="my-6 my-md-0"
      >
        <span
          class="py-4"
          :class="$vuetify.breakpoint.smAndDown ?
            'neutral--text text--tone-900' : 'brand-primary--text text--tone-400'"
        >
          {{ title }}
        </span>
      </BaseSubheader>
    </template>

    <template #actions>
      <BaseButton
        class="d-md-none pr-0"
        link
        color="transparent"
        :ripple="false"
        :height="24"
        @click="resetFilters"
      >
        <div class="brand-secondary--text text-body-m">
          {{ headerActionButtonText }}
        </div>
      </BaseButton>
    </template>

    <template #content>
      <div class="d-md-none">
        <BaseFilter
          v-for="filter, key in filtersItems"
          :key="key"
          :label="filter.label"
          :placeholder="filter.placeholder"
          class="mb-4"
          :items="filter.items"
          :modal-title="filter.label"
          :submit-button-text="filtersSubmitButtonText"
          :multiple="filter.multiple"
          :text-value="filterText(filter.attribute, filter.multiple)"
          @change="saveFilter($event, filter.attribute, filter.multiple)"
        />

        <v-divider class="mb-4 neutral tone-200"/>

        <BaseButton
          class="w-100"
          color="brand-primary tone-400"
          :height="56"
          @click="$emit('filter')"
        >
          <div class="white--text text-body-m-bold">
            {{ submitText }}
          </div>
        </BaseButton>
      </div>
      <div class="d-none d-md-block">
        <BaseCheckboxGroup
          v-for="filter, key in filtersItems"
          :key="key"
          :label="filter.label"
          class="mb-6"
          :items="filter.items"
          :multiple="filter.multiple"
          :max-fields="3"
          :button-text="checkboxGroupButtonText"
          @filter="saveFilter($event, filter.attribute, filter.multiple, true); $emit('filter')"
        />
      </div>
    </template>
  </BaseCard>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import BaseCard from '@/components/BaseCard.vue';
import { find } from 'lodash';
import BaseSubheader from '@/components/BaseSubheader.vue';
import BaseFilter from '@/components/BaseFilter.vue';
import BaseButton from '@/components/BaseButton.vue';
import BaseCheckboxGroup from '@/components/BaseCheckboxGroup.vue';

export default {
  components: {
    BaseCard,
    BaseSubheader,
    BaseFilter,
    BaseButton,
    BaseCheckboxGroup,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    filtersItems: {
      type: Array,
      required: true,
    },
    filtersSubmitButtonText: {
      type: String,
      required: true,
    },
    headerActionButtonText: {
      type: String,
      default: 'Supprimer tous les filtres',
    },
    submitText: {
      type: String,
      default: 'Filtrer',
    },
  },
  data() {
    return {
      showAllFilters: false,
    };
  },
  computed: {
    ...mapState(['campuses', 'sports', 'filters']),
    checkboxGroupButtonText() {
      return this.showAllFilters ? 'Voir plus' : 'Voir tout';
    },
  },
  methods: {
    ...mapActions([
      'setCoursesFilter',
      'resetFilters',
    ]),
    find,
    saveFilter(event, value, multiple) {
      if (event) {
        if (multiple) {
          this.setFilter(value, event);
        } else {
          this.setFilter(value, event[0]);
        }
      } else {
        this.setFilter(value, null);
      }
    },

    setCampusFilter(campusId) {
      this.setFilter('campus', campusId);
    },
    setSportFilter(sportId) {
      this.setFilter('sport', sportId);
    },
    setFilter(attribute, value) {
      this.setCoursesFilter({ filter: attribute, value });
    },
    setAvailabilityFilter(availabilityId) {
      this.setFilter('availability', availabilityId);
    },
    goToCourse(course) {
      this.$router.push(`/courses/${course.id}`);
    },

    filterText(attribute, multiple) {
      if (multiple) {
        if (this.filters[attribute].length === 0) {
          return 'Sélectionnez un filtre';
        }

        const labels = this.filters[attribute].map((filter) => {
          // eslint-disable-next-line max-len
          const relevantFilter = this.filtersItems.find((filterItem) => filterItem.attribute === attribute);
          // eslint-disable-next-line max-len
          const match = relevantFilter.items.find((item) => parseInt(item.id, 10) === parseInt(filter, 10));
          return match.attributes.name;
        });

        return labels.join(', ');
      }

      if (!this.filters[attribute]) {
        return 'Sélectionnez un filtre';
      }

      const data = this.filtersItems.find((item) => item.attribute === attribute);
      // eslint-disable-next-line max-len
      const match = data.items.find((item) => parseInt(item.id, 10) === parseInt(this.filters[attribute], 10));
      return match.attributes.name;
    },
  },
};
</script>
